import { createContext, useContext, useState, ReactNode } from 'react';

export enum LOCATIONS {
    FRANCE = 'fr',
    CANADA = 'ca',
    CANADA_AND_FRANCE = 'ca_fr',
    WORLDWIDE = 'ww',
}

type LocationContextType = {
    location: LOCATIONS | null;
    setLocation: (loc: LOCATIONS | null) => void;
};

const LocationContext = createContext<LocationContextType | undefined>(undefined);

export const LocationProvider = ({ children }: { children: ReactNode }): React.ReactElement | null => {
    const [location, setLocation] = useState<LOCATIONS | null>(null);
    return (
        <LocationContext.Provider value={{ location, setLocation }}>
            {children}
        </LocationContext.Provider>
    );
};

export const useLocation = () => {
    const context = useContext(LocationContext);
    if (!context) {
        throw new Error('useLocation must be used within a LocationProvider');
    }
    return context;
};
